/**
 * Story 564, settings.page.sections: the sections of the project settings page.
 *
 * The page lists exactly these, in this order. A section is added here when it
 * has settings to show, never before, so the list never offers an empty page.
 * Story 546 adds AI Services; the usage story adds Usage here.
 */

import type { ComponentType } from 'react';
import type { ProjectSettings } from '../../hooks/useProjectSettings';
import { TaskCompletionSection } from './TaskCompletionSection';
import { AiServicesSection } from './AiServicesSection';
import { SECTION_LABEL_TASK_COMPLETION, SECTION_LABEL_AI_SERVICES } from '../workspace/projectSettingsCopy';

/** What every section receives from the page. */
export interface SettingsSectionProps {
  projectSlug: string;
  settings: ProjectSettings;
  /** True for anyone but the owner; the page shows the one note that says so. */
  readOnly: boolean;
  /** A write was refused because the viewer is not the owner; the page turns read-only. */
  onRefusedForRole: () => void;
}

export interface SettingsSection {
  /** The value of the settings parameter that shows this section. */
  id: string;
  label: string;
  Component: ComponentType<SettingsSectionProps>;
}

export const SETTINGS_SECTIONS: readonly SettingsSection[] = [
  { id: 'task-completion', label: SECTION_LABEL_TASK_COMPLETION, Component: TaskCompletionSection },
  { id: 'ai-services', label: SECTION_LABEL_AI_SERVICES, Component: AiServicesSection },
];
